import * as Sentry from "@sentry/browser";
import { default as React } from "react";
import "react-app-polyfill/ie11";
import * as ReactDOM from "react-dom/client";
import smoothscroll from "smoothscroll-polyfill";
import { getArea } from "../shared/getArea";
import ReservationForm from "./components/ReservationForm";
// kick off the polyfill!
smoothscroll.polyfill();
Sentry.init({
    dsn: process.env.SENTRY_DSN,
    release: process.env.VERSION,
});
const ele = document.getElementById("reservation-app");
if (ele) {
    const root = ReactDOM.createRoot(ele);
    root.render(React.createElement(ReservationForm, { area: getArea() }));
}
